import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Signin from './components/auth/Signin';
import Signout from './components/auth/Signout';
import Footer from './components/Footer';
import Header from './components/Header';
import Loading from './components/Loading';
import requireAuth from './components/requireAuth';
import Sidenav from './components/Sidenav';
import Welcome from './components/Welcome';

// Lazy load route components for code splitting
const OrderList = lazy(() => import('./components/OrderList'));
const DeliveryList = lazy(() => import('./components/DeliveryList'));
const ReportSearch = lazy(() => import('./components/ReportSearch'));
const RemakeList = lazy(() => import('./components/RemakeList'));
const RemakeReport = lazy(() => import('./components/RemakeReport'));
const TipReport = lazy(() => import('./components/TipReport'));
const ThroughputReport = lazy(() => import('./components/ThroughputReport'));

const App = () => {
  return (
    <BrowserRouter>
      <Sidenav />
      <Header />
      <main>
        <div className="center-align">
          <Route path="/" exact component={Welcome} />
          <Route path="/signin" exact component={Signin} />
          <Route path="/signout" exact component={Signout} />
          <Suspense fallback={<Loading />}>
            <Route path="/order-list" exact component={OrderList} />
            <Route path="/delivery-list" exact component={DeliveryList} />
            <Route path="/report-search" exact component={ReportSearch} />
            <Route path="/remake-report" exact component={RemakeReport} />
            <Route path="/tip-report" exact component={TipReport} />
            <Route
              path="/throughput-report"
              exact
              component={ThroughputReport}
            />
            <Route
              path="/remake-list"
              exact
              component={requireAuth(RemakeList)}
            />
          </Suspense>
        </div>
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
